import {
  Box,
  Icon,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import RecruitmentPagination from 'module/recruitment/reusable/RecruitmentPagination'
import React, { useMemo } from 'react'
import { useTable } from 'react-table'

const UpskillTable = ({
  data,
  column,
  stickyHeader,
  nav,
  onClick,
  sx,
  sxHeader,
  sxCell,
  sxNav,
  error,
  isLoading,
  type,
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  ...rest
}) => {
  const tableHeader = useMemo(() => column, [column])
  const tableInstance = useTable({
    columns: tableHeader,
    data: data,
  })
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance

  if (isLoading) {
    return (
      <TableContainer
        sx={{
          backgroundColor: 'white.main',
          // border: 1,
          borderBottom: 0,
          // borderColor: 'gray-line.main',
          boxShadow: '0px 0px 10px lightgray',
          '& th.MuiTableCell-root': {
            padding: '6.5px 30px',
          },
          '& td.MuiTableCell-root': {
            padding: '0px',
          },
          ...sx,
        }}
        {...rest}
      >
        <Table stickyHeader={stickyHeader} {...getTableProps}>
          <TableHead
            sx={{
              backgroundColor: 'gray-background.main',
            }}
          >
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <TableCell align="center" {...column.getHeaderProps()}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: 'light-gray-text.main',
                        textAlign: 'left',
                        ...sxHeader,
                      }}
                    >
                      {column.render('Header')}
                    </Typography>
                  </TableCell>
                ))}
                {nav && (
                  <TableCell>
                    <Typography></Typography>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {Array.from({ length: 2 }).map((row) => {
              return (
                <TableRow>
                  {Array.from({ length: 2 }).map((cell, index) => {
                    return (
                      <TableCell align="center">
                        <Typography
                          sx={{
                            textAlign: index === 0 && 'left',
                            padding: '18px 30px',
                            ...sxCell,
                          }}
                        >
                          <Skeleton />
                        </Typography>
                      </TableCell>
                    )
                  })}
                  {nav && (
                    <TableCell align="right">
                      <Typography
                        variant="subtitle1"
                        sx={{
                          color: 'alternate.main',
                          cursor: 'pointer',
                          padding: '18px 30px',
                          ...sxNav,
                        }}
                      >
                        <Skeleton />
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )
  } else if (data.length < 1 || error) {
    return (
      <TableContainer
        sx={{
          backgroundColor: 'white.main',
          // borderRadius: '4.5px 4.5px 0px 0px',
          // border: 1,
          borderBottom: 0,
          // borderColor: 'gray-line.main',
          // boxShadow: '0px 0px 10px lightgray',
          '& th.MuiTableCell-root': {
            padding: '6.5px 30px',
          },
          '& td.MuiTableCell-root': {
            padding: '0px',
          },
          ...sx,
        }}
        {...rest}
      >
        <Table stickyHeader={stickyHeader} {...getTableProps}>
          <TableHead
            sx={{
              backgroundColor: 'gray-background.main',
            }}
          >
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <TableCell align="center" {...column.getHeaderProps()}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: 'light-gray-text.main',
                        textAlign: 'left',
                        ...sxHeader,
                      }}
                    >
                      {column.render('Header')}
                    </Typography>
                  </TableCell>
                ))}
                {nav && (
                  <TableCell>
                    <Typography></Typography>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableHead>
        </Table>
        {type === 'course progress' ? (
          <AdxEmptyStateV2 icon={<Icon>error</Icon>} title={`No ${type}  found`} />
        ) : (
          <AdxEmptyStateV2 icon={<Icon>error</Icon>} title={`No ${type}  found`} />
        )}
      </TableContainer>
    )
  } else {
    return (
      <>
        <TableContainer
          sx={{
            backgroundColor: 'white.main',
            // borderRadius: '4.5px 4.5px 0px 0px',
            // border: 1,
            borderBottom: 0,
            // borderColor: 'gray-line.main',
            // boxShadow: '0px 0px 10px lightgray',
            '& th.MuiTableCell-root': {
              padding: '6.5px 30px',
            },
            '& td.MuiTableCell-root': {
              padding: '0px',
            },
            ...sx,
          }}
          {...rest}
        >
          <Table stickyHeader={stickyHeader} {...getTableProps}>
            <TableHead
              sx={{
                backgroundColor: 'gray-background.main',
              }}
            >
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) => (
                    <TableCell align="center" {...column.getHeaderProps()}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          color: 'light-gray-text.main',
                          textAlign:
                            (type === 'staff' ||
                              type === 'course progress' ||
                              type === 'staff course') &&
                            index > 0
                              ? 'center'
                              : 'left',
                          ...sxHeader,
                        }}
                      >
                        {column.render('Header')}
                      </Typography>
                    </TableCell>
                  ))}
                  {nav && (
                    <TableCell>
                      <Typography></Typography>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableHead>
            <TableBody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row)
                return (
                  <TableRow {...row.getRowProps()}>
                    {row.cells.map((cell, index) => {
                      return (
                        <TableCell align="center" {...cell.getCellProps()}>
                          <Typography
                            sx={{
                              textAlign: index === 0 && 'left',
                              padding: '18px 30px',
                              ...sxCell,
                            }}
                          >
                            {cell.render('Cell')}
                          </Typography>
                        </TableCell>
                      )
                    })}
                    {nav && (
                      <TableCell align="right">
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: 'alternate.main',
                            cursor: 'pointer',
                            padding: '18px 30px',
                            ...sxNav,
                          }}
                          onClick={() => onClick(row.original)}
                        >
                          {nav}
                        </Typography>
                      </TableCell>
                    )}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {count && (
          <Box
            display="flex"
            justifyContent="flex-end"
            bgcolor="white.main"
            mb={6}
            sx={{ width: '100%' }}
          >
            <RecruitmentPagination
              count={count}
              page={page}
              onPageChange={onPageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={onRowsPerPageChange}
            />
          </Box>
        )}
      </>
    )
  }
}

export default UpskillTable
